tableScroll = function(){
  var Swiper = require('swiper');
  var tableScroll = new Swiper('.case_table-swiper', {
      scrollbar: '.swiper-scrollbar',
      slidesPerView: 'auto',
      mousewheelControl: true,
      freeMode: true
  });
}

module.exports = tableScroll;
